import React from 'react';

import Box from '@mui/material/Box';

import { styledComponent } from 'src/utils/styled';

const RightArea = styledComponent(Box)`
    background: center / cover no-repeat url('${process.env.NEXT_PUBLIC_SITE_URL}/assets/images/estimation/patio.jpeg')
`;

RightArea.defaultProps = {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

const EstimateRightArea: React.FC = () => <RightArea />;

export default EstimateRightArea;
